<template>
  <section>
	<h2>Create Cards for your Children</h2>
    <v-alert
      v-if="show_alert"
      :type="alert_type"
    >
      {{ alert_text }}
    </v-alert>
    
    <!--<v-switch
			v-model="enabled"
			label="Enabled"
    ></v-switch>-->
    <div id="existing_child_accounts" v-if="existing_child_accounts">
        <v-data-table
        :headers="headers"
        :items="children"
        item-key="name"
        >
            <template v-slot:item.card_number="{ item }">
                <router-link :to="{ name: 'card', params: { child_customer_id: item.customer_id }}">Display</router-link>
            </template>
            <template v-slot:item.invite_link="{ item }">
                <a :href="item.invite_link">Link</a>
            </template>
            <template v-slot:item.send_money="{ item }">
                <router-link :to="{ name: 'transfer' }">Send Money</router-link>
            </template>
        </v-data-table>
    </div>
    <div id="new_child_form">
        <v-text-field
        label="Child's First Name"
        v-model="first_name"
        ></v-text-field>
        <v-btn color="primary" @click="add_child_account" :loading="pending_submit">Create Card</v-btn>
    </div>
  </section>
</template>

<script>

export default {
	props: ['user','api_prefix'],
	data() {
		return {
          pending_submit: false,
          show_alert: false,
          alert_type: 'success',
          existing_child_accounts: false,
          first_name: null,
          alert_text: null,
          headers: [
            { text: 'Name', value: 'name' },
            { text: 'Account Balance', value: 'account_balance' },
            { text: 'Card #', value: 'card_number' },
            { text: 'Invite Link', value: 'invite_link' },
            { text: 'Send Money To', value: 'send_money' },
          ],
          children: [{}],
          limit: 0,
		};
	},
	mounted: function() 
	{
		
	},
	watch: {
    
	},
	computed: {
		
	},
	methods: {
      async get_child_accounts()
      {
        let self = this
        var response = await self.$http.get(self.api_prefix + '/child_account',
          {
          },
        );
        if(response.data!=null)
        {
            self.children = response.data
        }
      },
      async display_card_details(customer_id)
      {
        var response = await self.$http.get(self.api_prefix + '/card_details',
          {
              "customer_id": customer_id
          },
        );
        if(response.data!=null)
        {
            //display in a new div that becomes visible at very top, embedded card component
        }
      },
      async add_child_account()
      {
        this.pending_submit = true
        let self = this;

        var response = await self.$http.post(self.api_prefix + '/child_account',
          {
            "first_name": self.first_name,
          },
        );
        if(response.data!=null)
        {
          if(response.data.status==true)
          {
            self.alert_text = "Your card has been created!"
            self.alert_type = 'success'
            self.show_alert = true;

            self.get_child_accounts();//refresh

            window.analytics.track("Card Created", {
                'succesful': true,
            });
          }
          else
          {
            self.alert_text = "We were unable to create your card - please chat with support."
            self.alert_type = 'error'
            self.show_alert = true;
            window.analytics.track("Card Created", {
                'succesful': false,
            });
          }
        }
        this.pending_submit = false
        this.$emit('card_created')
      }
	},
	async created() 
	{
        window.analytics.page('Family')
	}
};
</script>
